import { useTranslation } from 'react-i18next';
import { selectCompactFieldClass } from './form/fieldClasses';

const OPTIONS = [
  { value: 'en', labelKey: 'lang.en' as const },
  { value: 'zh', labelKey: 'lang.zh' as const },
];

export function LanguageSelect() {
  const { i18n, t } = useTranslation();
  return (
    <label className="flex items-center gap-2 text-sm text-slate-600">
      <select
        aria-label={t('common.language')}
        className={selectCompactFieldClass}
        value={i18n.language.startsWith('zh') ? 'zh' : 'en'}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {t(o.labelKey)}
          </option>
        ))}
      </select>
    </label>
  );
}
